import React from 'react';
import MetricsCard from '../../dashboard-overview/components/MetricsCard';
import DonutSplitChart from '../../dashboard-overview/components/DonutSplitChart';
import BarSplitChart from '../../dashboard-overview/components/BarSplitChart';
import ReportTrendChart from './ReportTrendChart';
import { formatHours } from '../../../utils/duration';

const CARD = 'rounded-md border border-dash-border bg-dash-card p-4';

const ExecutiveSummary = ({ summary, loading, filters }) => {
  const s = summary;
  const pop = s?.periodOverPeriod;

  const kpis = s
    ? [
        { title: 'Total (terminal)', value: String(s.totals.total), subtitle: `${s.totals.live} live · ${s.totals.deleted} deleted`, color: 'primary' },
        { title: 'Active', value: String(s.active.total), subtitle: `${s.active.deleted} deleted`, color: 'success' },
        { title: 'Rejected', value: String(s.rejected.total), subtitle: `${s.rejected.deleted} deleted`, color: 'destructive' },
        { title: 'Rejection Rate', value: `${s.rejectionRatePct}%`, subtitle: 'of resolved', color: 'warning' },
        { title: 'Avg Turnaround', value: formatHours(s.avgTurnaroundHours), subtitle: 'link → code', color: 'neutral' },
        ...(pop
          ? [{
              title: 'Onboarded (period)',
              value: String(pop.current),
              change: pop.deltaPct != null ? `${pop.deltaPct > 0 ? '+' : ''}${pop.deltaPct}% vs prior` : 'vs prior',
              subtitle: `prior: ${pop.prior}`,
              color: 'primary',
            }]
          : []),
      ]
    : [];

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-sm font-semibold text-dash-foreground">Executive Summary</h2>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {loading && !s
          ? Array.from({ length: 6 }).map((_, i) => <div key={i} className={`${CARD} h-[76px] animate-pulse`} />)
          : kpis.map((k) => <MetricsCard key={k.title} {...k} />)}
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        <div className={CARD}>
          <ReportTrendChart filters={filters} />
        </div>
        {/* Three charts cannot share one row of this half-width card: a 120px
            donut plus its name/count/% legend needs ~300px, and the Country bar
            chart needs about as much again. Two rows instead — the donuts split
            the top row, Country gets the full width below. */}
        <div className={`${CARD} grid grid-cols-1 gap-4 sm:grid-cols-2`}>
          <DonutSplitChart
            title="MSME"
            endpoint="/reports/mis/distribution"
            params={{ dimension: 'msme', ...filters }}
            height={110}
          />
          <DonutSplitChart
            title="Region"
            endpoint="/reports/mis/distribution"
            params={{ dimension: 'region', ...filters }}
            height={110}
          />
          <div className="sm:col-span-2">
            <BarSplitChart
              title="Country"
              endpoint="/reports/mis/distribution"
              params={{ dimension: 'country', limit: 6, ...filters }}
              barColor="var(--dash-chart-3)"
              areaClassName="h-[150px]"
              showPercent
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveSummary;
